import { FunctionalComponent, h } from "@stencil/core";
import clsx from "clsx";

interface SuccessProps {
  icon: string;
  content: string;
  getClass: (path: string) => string;
}

export const Success: FunctionalComponent<SuccessProps> = (props) => {
  const {
    icon,
    content,
    getClass,
  } = props;

  return (
    <div class={clsx("hr-success", getClass('success'))}>
      <div class={clsx("hr-success-icon", getClass('successIcon'))}>
        {icon}
      </div>
      <div class={clsx("hr-success-content", getClass('successContent'))}>
        {content}
      </div>
    </div>
  )
}
